@if (message(); as message) {
  <button (click)="toggleReactionsBar($event)" matTooltip="Reaktion hinzufügen" mat-icon-button>
    <mat-icon svgIcon="add-reaction"></mat-icon>
  </button>
  @if (this.isReactionBarOpened) {
    <emoji-mart
      [attr.data-testid]="testIds.fieldReactionBar"
      class="custom-emoji-mart"
      [ngClass]="clientService.client.getUserId() === message.senderId ? 'senderMsgReaction' : 'receivedMsgReaction'"
      [showPreview]="false"
      [exclude]="['flags']"
      (click)="$event.stopPropagation()"
      (emojiClick)="sendReaction(message.reactionsArray, message.eventId, $event)"
      [i18n]="TRANSLATIONS"
      (keydown)="$event.stopPropagation()">
    </emoji-mart>
  }
}
